import { useEffect, useRef } from "react";

declare global {
  interface Window {
    zE?: (action: string, ...args: any[]) => void;
    zESettings?: any;
  }
}

interface ZendeskChatProps {
  candidateZendeskJwt?: string;
}

const ZendeskChat = ({ candidateZendeskJwt }: ZendeskChatProps) => {
  const jwtRef = useRef<string | undefined>(candidateZendeskJwt);
  const scriptInitRef = useRef(false);

  useEffect(() => {
    jwtRef.current = candidateZendeskJwt;
  }, [candidateZendeskJwt]);

  useEffect(() => {
    const zendeskKey = import.meta.env.VITE_ZENDESK_KEY as string | undefined;
    if (!zendeskKey || !candidateZendeskJwt) return;
    if (scriptInitRef.current) return;

    scriptInitRef.current = true;
    window.zESettings = {
      webWidget: {
        launcher: {
          label: {
            "*": "Aide CIFMD",
          },
        },
        position: {
          horizontal: "right",
          vertical: "top",
        },
        offset: {
          vertical: "5px",
          horizontal: "260px",
        },
        authenticate: {
          chat: {
            jwtFn: (callback: (jwt: string) => void) => {
              const jwt = jwtRef.current;
              if (jwt) {
                callback(jwt);
              }
            },
          },
        },
      },
    };

    const existingScript = document.getElementById("ze-snippet");
    if (existingScript) return;

    const script = document.createElement("script");
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    script.async = true;
    script.id = "ze-snippet";
    document.body.appendChild(script);
  }, [candidateZendeskJwt]);

  return null;
};

export default ZendeskChat;
